import React, {useContext, useEffect, useReducer} from 'react';
import { object } from 'prop-types';
import {isAbleToFetchShops, isStateMenuOpen, isStateShopsOpen} from "./utils";
import {useQuery} from "react-query";
import {fetchShops} from "../api/shop";
import {getGeolocation} from "../common/geoloc";
import {useUiContext} from "./uiContext";

export const MOBILE_DISPLAY_STATE = {
    CLOSED: 'CLOSED',
    MENU_OPEN: 'MENU_OPEN',
    SHOP_LIST_OPEN: 'SHOP_LIST_OPEN',
}

const SET_MOBILE_STATE = 'SET_MOBILE_STATE';
const SET_SHOPS_QUERY_STATE = 'SET_SHOPS_QUERY_STATE';
const SET_SHOPS_QUERY_PARAMS = 'SET_SHOPS_QUERY_PARAMS';

const detailsSheetContext = React.createContext();

const reducerFactory = () => {
    return (state, action) => {
        switch (action.type) {
            case SET_SHOPS_QUERY_PARAMS:
                return {
                    ...state,
                    shopsQueryParams: action.payload,
                }
            case SET_SHOPS_QUERY_STATE:
                return {
                    ...state,
                    shopsQueryState: action.payload,
                }
            case SET_MOBILE_STATE:
                return {
                    ...state,
                    bodyOverflowHidden: isStateShopsOpen(action.payload),
                    mobileDisplayState: action.payload,
                }
            default:
                return state
        }
    }
};

const DetailsSheetContextProvider = (props) => {

    const initialState = props.initialState || {
        mobileDisplayState: MOBILE_DISPLAY_STATE.CLOSED,
        bodyOverflowHidden: false,
        shops: [],
        gtmClassName: props.gtmClassName,
        shopsQueryParams: {
            latitude: null,
            longitude: null,
            formula: props.formula,
        },
        shopsQueryState: null,
    };

    const [state, dispatch] = useReducer(reducerFactory(), initialState);

    const setStateClosed = () => dispatch({type: SET_MOBILE_STATE, payload: MOBILE_DISPLAY_STATE.CLOSED});
    const setStateMenuOpen = () => dispatch({type: SET_MOBILE_STATE, payload: MOBILE_DISPLAY_STATE.MENU_OPEN});
    const setStateShopsOpen = () => dispatch({type: SET_MOBILE_STATE, payload: MOBILE_DISPLAY_STATE.SHOP_LIST_OPEN});

    console.log('shopsQueryParams', isAbleToFetchShops(state))

    let fetchShopQueryResult = useQuery(["shops", state.shopsQueryParams], fetchShops, {
        enabled: isAbleToFetchShops(state) && !initialState.shops.length > 0
    });

    const [{isMobile}] = useUiContext();

    const contextValue = [
        {...state, shopsQueryState: fetchShopQueryResult},
        {
            setStateClosed,
            setStateMenuOpen,
            setStateShopsOpen,
            dispatch,
        },
    ];

    // handle body overflow when modal is displayed
    useEffect(()=>{
        if(state.bodyOverflowHidden)
            document.body.classList.add('overflow-hidden');
        else document.body.classList.remove('overflow-hidden');
    }, [state.bodyOverflowHidden]);

    useEffect(()=>{
        if(isMobile)
            getGeolocation().then((payload)=>{
                dispatch({type: SET_SHOPS_QUERY_PARAMS, payload: {
                    formula: 'f_one',
                    lat: payload.coords.latitude,
                    long: payload.coords.longitude,
                }});
            })

    }, [state.mobileDisplayState, isMobile])


    return <detailsSheetContext.Provider value={contextValue}>{props.children}</detailsSheetContext.Provider>;
}

DetailsSheetContextProvider.propTypes = {
    initialState: object,
};

export default DetailsSheetContextProvider;
export const useDetailsSheetContext = () => useContext(detailsSheetContext);

